import api from 'react/signups/card/api';
import COOKBOOK_V1 from 'react/signups/card/recipes/v1';

export const findCookbook = () => COOKBOOK_V1;

export const goTo = (cardAccountSignupId, currentModule, currentPath, path, navigate) => {
  if (cardAccountSignupId) {
    api.createSignupLog(cardAccountSignupId, {
      moduleName: currentModule,
      completedAt: new Date().toISOString(),
      completedPage: currentPath,
      nextPage: path,
    });
  }

  // clear any flash messages from previous page
  window.Truelink && window.Truelink.flashClear();

  // reset to top
  window.scrollTo(0, 0);

  navigate(path);
};

export const goBack = (navigate) => {
  navigate(-1);
};

export const getNextPath = ({ location, recipe, userType }) => {
  const currentPath = location.pathname;
  const { sequence: stepNames } = recipe.variants[userType];
  const currentStepIndex = stepNames.findIndex((val) => val === currentPath);
  return stepNames[currentStepIndex + 1];
};

export const goToNextStep = ({
  cardAccountSignupId,
  location,
  navigate,
  recipe,
  moduleComplete,
  setModuleComplete,
  userType,
}) => {
  const currentPath = location.pathname;
  const currentModule = recipe.name;
  const nextPath = getNextPath({ location, recipe, userType });
  const { next: nextModule } = recipe.variants[userType];

  if (nextPath) {
    goTo(cardAccountSignupId, currentModule, currentPath, nextPath, navigate);
  } else if (moduleComplete) {
    goTo(cardAccountSignupId, currentModule, currentPath, nextModule, navigate);
  } else {
    setModuleComplete(true);
  }
};

export const shortenRecipe = ({ skipPaths, recipe, userType }) => {
  const fullSequence = recipe.variants[userType]?.sequence;
  if (!fullSequence) return recipe;

  const skippedSequence = fullSequence.filter((path) => !skipPaths.includes(path));

  return {
    ...recipe,
    variants: {
      ...recipe.variants,
      [userType]: {
        ...recipe.variants[userType],
        sequence: skippedSequence,
      },
    },
  };
};

export const lengthenRecipe = ({ addAfterPath, addPaths, recipe, userType }) => {
  const currentSequence = recipe.variants[userType]?.sequence;
  if (!currentSequence) return recipe;

  // don't duplicate existing paths
  const dedupedSequence = currentSequence.filter((path) => !addPaths.includes(path));

  const index = dedupedSequence.findIndex((path) => path === addAfterPath);

  // inject new paths into recipe sequence
  const extendedSequence = dedupedSequence
    .slice(0, index + 1)
    .concat(addPaths)
    .concat(dedupedSequence.slice(index + 1));

  return {
    ...recipe,
    variants: {
      ...recipe.variants,
      [userType]: {
        ...recipe.variants[userType],
        sequence: extendedSequence,
      },
    },
  };
};

export const overrideNextModule = ({ nextModule, recipe, userType }) => {
  const nextItem = recipe.variants[userType]?.next;
  if (!nextItem) return recipe;

  return {
    ...recipe,
    variants: {
      ...recipe.variants,
      [userType]: {
        ...recipe.variants[userType],
        next: nextModule,
      },
    },
  };
};
